import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore'; 

import {
    submitSystemAdminUpdateClient,
    submitSystemAdminCreateClient
} from '../../actions';
import SysadminFormsClientUpdate from '../../component/sysadmin/forms/client/update';

class SysadminClientUpdatePage extends Component { 
 
    componentDidUpdate(prevProps, prevState){
        if (prevProps.location.state != this.props.location.state){ 
            window.location.href = window.location.href
        }
    }
    render() { 
        const {clientId} = this.props.match.params;
        let selectedClientData
        if (this.props.location.state && this.props.location.state.client){ 
            selectedClientData=this.props.location.state.client
        }else {
             selectedClientData = _.find(this.props.clients, (client) => client._id === clientId);
        }  
        return (
            <SysadminFormsClientUpdate
                user={this.props.user}
                clientId={clientId}
                client={selectedClientData}
                submitSystemAdminUpdateClient={this.props.submitSystemAdminUpdateClient}
                cloneClient={this.props.submitSystemAdminCreateClient}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        clients: state.systemAdmin.clients,
    };
}

export default connect(mapStateToProps, {
    submitSystemAdminUpdateClient,
    submitSystemAdminCreateClient
})(SysadminClientUpdatePage);